import React, {useMemo} from 'react';
import {useShallow} from 'zustand/react/shallow';
import {List} from 'immutable';

import {useIsAnnotationModeActive} from 'client/components/PracticeView/Annotations/mode/useIsAnnotationModeActive';
import FreeEntryInputArea from '../FreeEntryInputArea.react';
import {useQuestionTranslationStore} from '../../shared/TranslationSection/TranslationStore';
import type {QuestionComponentProps} from '../../shared/QuestionComponent/QuestionComponent.react';

interface FreeEntryInputWrapperProps extends QuestionComponentProps {
  isGuessSubmitted?: boolean;
}

const FreeEntryInputWrapper = (props: FreeEntryInputWrapperProps) => {
  const {showTranslations, translatedInfo} = useQuestionTranslationStore(
    useShallow((state) => ({
      showTranslations: state.showTranslations && state.translationSettings.question,
      translatedInfo: state.translatedQuestionInfo
    }))
  );

  const areAnswersLocked = useIsAnnotationModeActive() && !props.isGuessSubmitted;

  const translatedInputs = useMemo(() => {
    const formattedInfo = translatedInfo?.inputs?.map((inputInfo) => {
      return {
        ...inputInfo,
        getId: () => inputInfo.id,
        getText: () => inputInfo.text
      };
    });
    return List(formattedInfo || []);
  }, [translatedInfo]);

  return (
    <FreeEntryInputArea
      {...props}
      showTranslations={showTranslations}
      translatedInputs={translatedInputs}
      areAnswersLocked={areAnswersLocked}
    />
  );
};

export default FreeEntryInputWrapper;
